import { Chunk, HashSet, pipe, Schema, String as Str, SchemaGetter } from 'effect';

import type { TaxonFilterStateSet } from '../state/taxon';
import {
  TaxonFilterStateSet as TaxonFilterStateSetSchema,
  TaxonCode as TaxonCodeSchema,
} from '../state/taxon';

const taxonFilterStateSetToApiString = (taxonSet: TaxonFilterStateSet): string =>
  pipe(taxonSet, Chunk.fromIterable, Chunk.join(','));

const apiStringToTaxonFilterStateSet = (taxonString: string): TaxonFilterStateSet => {
  if (taxonString === '') {
    return HashSet.empty();
  }

  return pipe(
    taxonString,
    Str.split(','),
    Chunk.fromIterable,
    Chunk.filter((s) => s.length > 0),
    Chunk.map((s) => TaxonCodeSchema.make(s)),
    HashSet.fromIterable
  );
};

export const TaxonApiQuery = Schema.Struct({
  taxon: Schema.optional(Schema.String),
});

export const TaxonToApi = Schema.toType(TaxonFilterStateSetSchema).pipe(
  Schema.decodeTo(TaxonApiQuery, {
    decode: SchemaGetter.transform((taxonSet) => {
      const taxonString = taxonFilterStateSetToApiString(taxonSet);
      return taxonString.length > 0 ? { taxon: taxonString } : {};
    }),
    encode: SchemaGetter.transform((apiData) =>
      apiStringToTaxonFilterStateSet(apiData.taxon ?? '')
    ),
  })
);
